import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { getItem } from "actions/chargers/main/actions";
import Loading from "views/lib/Loading";

import getProgressBar from "../../helpers/get-progress-bar";
import { VOLTAGE, AMPERAGE } from "../../constants";


const InfoPowerBank = ({
                         pb,
                         getItem,
                       }) => {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getItem(pb.id, (response) => {
      setItem(response);
      setLoading(false);
    });
  }, [pb]);

  if (loading) {
    return <Loading state={loading}/>;
  }

  if (!item) {
    return <div>404: Power bank not found</div>;
  }

  return (
    <div className="card mb-0">
      <table className="table table-hover table-bordered table-striped table-align-middle table-sm mb-0">
        <tbody>
        <tr>
          <td>ID</td>
          <td>{item.id}</td>
        </tr>
        <tr>
          <td>Status</td>
          <td>{item.status}</td>
        </tr>
        <tr>
          <td>Charging</td>
          <td>{item.charging ? "Yes" : "No"}</td>
        </tr>
        <tr>
          <td>Station QR</td>
          <td>{item.stationQr}</td>
        </tr>
        <tr>
          <td>Last Station QR</td>
          <td>{item.lastStationQr}</td>
        </tr>
        <tr>
          <td>Slot Number</td>
          <td>{item.slotNumber}</td>
        </tr>
        <tr>
          <td>Lock Level</td>
          <td>{item.lockLevel}</td>
        </tr>
        <tr>
          <td>Bottom Level</td>
          <td>{item.bottomLevel}</td>
        </tr>
        <tr>
          <td>Electric Quantity</td>
          <td>{getProgressBar(item.electricQuantity, {
            min: 0,
            max: 100
          }, false)}</td>
        </tr>
        <tr>
          <td>Voltage</td>
          <td>{getProgressBar(item.voltage, VOLTAGE)}</td>
        </tr>
        <tr>
          <td>Amperage</td>
          <td>{getProgressBar(item.amperage, AMPERAGE)}</td>
        </tr>
        <tr>
          <td>Temperature</td>
          <td>{item.temperature}c</td>
        </tr>
        <tr>
          <td>Last Rent User</td>
          <td>
            {item.lastRentUser ? (
              <div>
                <Link to={`/users/${item.lastRentUser}`}>
                  {item.lastRentUser}
                </Link>
                <span>{moment(item.lastRentDate)
                  .format("HH:mm YYYY-MM-DD")}</span>
              </div>
            ) : "N/A"}
          </td>
        </tr>
        <tr>
          <td>Last Updated Date</td>
          <td>{item.lastUpdatedAt ? moment(item.lastUpdatedAt)
            .format("HH:mm YYYY-MM-DD") : "N/A"}</td>
        </tr>
        <tr>
          <td colSpan="2" className="text-center">Admin</td>
        </tr>
        <tr>
          <td>Email</td>
          <td>{item.adminEmail}</td>
        </tr>
        <tr>
          <td>Action</td>
          <td>{item.adminAction}</td>
        </tr>
        <tr>
          <td>Action Date</td>
          <td>{item.adminActionDate ? moment(item.adminActionDate)
            .format("HH:mm YYYY-MM-DD") : "N/A"}</td>
        </tr>

        </tbody>
      </table>
    </div>
  );
};

const mapStateToDispatch = dispatch => ({
  getItem: bindActionCreators(getItem, dispatch),
});

export default connect(null, mapStateToDispatch)(InfoPowerBank);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/stations/single/info-power-bank.js